/**
 * CTA button – professional, government-facing
 */

import React from 'react';
import clsx from 'clsx';

export interface LandingBeamButtonProps {
  href: string;
  children: React.ReactNode;
  primaryColor?: string;
  className?: string;
}

export function LandingBeamButton({ href, children, primaryColor = '#3b82f6', className }: LandingBeamButtonProps) {
  return (
    <a
      href={href}
      className={clsx(
        'inline-flex items-center justify-center rounded-lg px-8 py-3.5 text-base font-semibold text-white no-underline transition-colors hover:opacity-95',
        className
      )}
      style={{
        backgroundColor: primaryColor,
      }}
    >
      {children}
    </a>
  );
}
